import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer style={{
      backgroundColor: '#1e1e1e',
      color: 'white',
      padding: '1rem',
      marginTop: 'auto'
    }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <div>
          <h3>DISCLAIMER</h3>
          <p>The information contained herein does not constitute investment advice and made available for educational purposes only. Prices and returns on equities are listed without consideration of fees, commissions, taxes, penalties, or interest payable due to purchasing, holding, or selling.</p>
        </div>
        <div style={{ marginTop: '1rem' }}>
          <ul style={{ listStyle: 'none', padding: 0, display: 'flex', justifyContent: 'center', gap: '1rem' }}>
            <li><Link to="/privacy-policy" style={{ color: 'white', textDecoration: 'none' }}>Privacy Policy</Link></li>
            <li><Link to="/terms-of-service" style={{ color: 'white', textDecoration: 'none' }}>Terms of Service</Link></li>
            <li><Link to="/about" style={{ color: 'white', textDecoration: 'none' }}>About</Link></li>
            <li><Link to="/affiliate-program" style={{ color: 'white', textDecoration: 'none' }}>Affiliate Program</Link></li>
          </ul>
        </div>
      </div>
      <div style={{ textAlign: 'center', marginTop: '1rem' }}>
        <p>Copyright © 2025 VersaQuant</p>
      </div>
    </footer>
  );
};

export default Footer;
